var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63346 4.18938C2.89973 4.18938 3.1551 4.0836 3.34338 3.89532C3.53166 3.70704 3.63744 3.45167 3.63744 3.1854C3.63744 2.91912 3.53166 2.66376 3.34338 2.47547C3.1551 2.28719 2.89973 2.18142 2.63346 2.18142C2.36718 2.18142 2.11182 2.28719 1.92353 2.47547C1.73525 2.66376 1.62947 2.91912 1.62947 3.1854C1.62947 3.45167 1.73525 3.70704 1.92353 3.89532C2.11182 4.0836 2.36718 4.18938 2.63346 4.18938ZM10.6051 5.91623C10.846 6.15718 11 6.49184 11 6.86666C11 7.23479 10.8527 7.56945 10.6051 7.81041L7.25846 11.157C7.13432 11.2818 6.98674 11.3808 6.82421 11.4484C6.66168 11.5159 6.48739 11.5507 6.31138 11.5507C6.13536 11.5507 5.96107 11.5159 5.79854 11.4484C5.63601 11.3808 5.48843 11.2818 5.36429 11.157L0.685732 6.47846C0.438083 6.23081 0.290833 5.89615 0.290833 5.52802V2.18142C0.290833 1.43847 0.886528 0.842773 1.62947 0.842773H4.97608C5.34421 0.842773 5.67887 0.990024 5.91982 1.23098L10.6051 5.91623Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsSelected);
export default __webpack_public_path__ + "static/media/TagsSelected.4b44a47f57cb5b273a85fbd971758d3b.svg";
export { ForwardRef as ReactComponent };